export default "__VITE_ASSET__CnkMUV8c__"